<template>
<section class="box mdc-typography"
  v-bind:class="{'mdc-elevation--z3' : showInCard}"
>
  <header class="box__header" v-if="showInCard"/>
  <div class="box__content">
    <div class="box__content__title">{{title}}</div>
    <!-- @slot Use this slot for the content of the box-->
    <slot name="content" />
  </div>
  <div class="box__button-panel">
    <!--@slot Use this slot for the buttons un the box -->
    <slot name="buttons" />
  </div>

  <slot name="usp" />
</section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['showInCard']),
  },
  props: {
    /**
     * title of the box
     */
    title: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../scss/colors";
  @import "../../../scss/variables";

  .box {
    color: $on-surface;
    font-size: $font-size-normal;
    width: 320px;
    min-width: 320px;
    max-width: 320px;
    border-radius: 3px;
    box-sizing: border-box;
    position: relative;
    background-color: $surface;

    @media screen and (max-width: 320px) {

      max-width: 100%;
      border-radius: 0;
    }

    &__header {
      height: 10px;
      background-color: $primary;
    }

    &__content {
      padding: 16px;
      position: relative;
      box-sizing: border-box;

      &__title {
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: bolder;
        letter-spacing: 0.0125em;
      }

    }
    &__button-panel {
      padding: 16px;
    }
  }
</style>

